import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';

@Component({
  selector: 'chartControl',
  templateUrl: './chart-control.component.html'
})
export class ChartControlComponent {

  @Output() getChartData = new EventEmitter();
  @Input() chartType: ChartType = 'bar';
  @Input() chartFor: string = '';
  @Input() chartIndex: number = 1;
  @Input() chartData: ChartDataSets[] = [];
  @Input() chartLabels: string[] = [];
  @Input() piechartData: number[];

  public chartLegend = false;
  public barChartColors: any[] = [{ backgroundColor: ['#A60000', '#E32C00', '#FFA895', '#FFB15D', '#FFCD00'] }];
  public barHRChartColors: any[] = [{ backgroundColor: ['#E6E6E6', '#428336', '#FFCD00', '#E32C00'] }];
  public barDueChartColors: any[] = [{ backgroundColor: ['#E6E6E6', '#C94578', '#51ACB8'] }];
  public barRiskChartColors: any[] = [{ backgroundColor: ['#A60000', '#70B397'] }];
  public barChart2Colors: any[] = [
    { backgroundColor: ['#4F99BB', '#4F99BB', '#4F99BB', '#4F99BB', '#4F99BB'] },
    { backgroundColor: ['#ACE5FF', '#ACE5FF', '#ACE5FF', '#ACE5FF', '#ACE5FF'] }
  ];

  public barChartPlugins = [pluginDataLabels];
  public barChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    tooltips: { enabled: false },
    hover: { mode: 'nearest', intersect: true },
    layout: { padding: { top: 30 } },
    plugins: {
      legend: { display: true },
      datalabels: {
        anchor: 'end', align: 'end',
        font: { size: 13, weight: 'bold' }
      },
    },
    scales: {
      xAxes: [{ gridLines: { display: false } }],
      yAxes: [{ gridLines: { display: false }, display: false, ticks: { beginAtZero: true } }]
    }
  };
  public pieChartPlugins = [];
  public pieChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: { position: 'left' },
    plugins: {}
  };
  public pieChartColors: any[] = [];
  public pieChart2Colors = [{ backgroundColor: ['#A60000', '#70B397'] }];
  public pieChart3Colors = [{ backgroundColor: ['#E35100', '#B1D48B', '#4F99BB'] }];

  public chartClicked(e: any, index: number) {
    if (e.active.length > 0) {
      const chart = e.active[0]._chart;
      const activePoints = chart.getElementAtEvent(e.event);
      if (activePoints.length > 0) {
        const clickedElementIndex = activePoints[0]._index;
        const label = chart.data.labels[clickedElementIndex];
        const value = chart.data.datasets[0].data[clickedElementIndex];
        let chartJson = { "label": label, "value": value, "index": index }
        this.getChartData.emit(chartJson);
      }
    }
  }

}
